import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import { AppContext } from '../../contexts/AppContext';

import { RoundTableLogo } from '../../images/logos/RoundTableLogo';
import { HamburgerMenuIcon } from '../../icons/HamburgerMenuIcon';

import { Btn } from '../shared/Btn';

import { SideNavbar } from './SideNavbar';

import '../../../css/components/navbar.scss';

export class Navbar extends Component {
  static contextType = AppContext;
  constructor(props){
    super(props);

    this.state = {
      expandedSideBar: false,
    }
  }

  toggleExpandSideBar = () => {
    this.setState({
      expandedSideBar: !this.state.expandedSideBar,
    })
  }

  render(){
    return (
      <div className={ `navbar-wrapper${ this.props.homePage ? ' navbar-wrapper--home-page':'' }` }>
        <div className={ `navbar${ this.props.darkTheme ? ' navbar--dark':'' }` }>
          <div className="left-side">
            <NavLink to="/">
              { this.props.darkTheme ? 
                <RoundTableLogo className="navbar-logo" color />
                :
                <RoundTableLogo color />
              }
            </NavLink>
          </div>
          <div className="right-side">
            {/* <Btn className={`contact-us Btn--white-outline`}> */}
            <Btn href="/contact" className={`contact-us`}>
              CONTACT
            </Btn>
            <HamburgerMenuIcon color={ this.props.darkTheme ? '#ffffff' : '#141414' }onClick={ this.toggleExpandSideBar }/>
          </div>
        </div>

        <SideNavbar expanded={ this.state.expandedSideBar } close={ this.toggleExpandSideBar }/>
      </div>
    )
  }
}